var baseConfig = {
    baseUrl: '',
    /** 
     * 请求环境，是否使用取决于baseConfig.isUseReqEnv
     * 如果为空，则根据process.env.NODE_ENV 和 isMock确定
     * 如果填入则强制改写为当前环境
     * @取值
     *  'dev' - 开发环境
     *  'test' - 测试环境
     *  'pro' - 生产环境
     *  'mock' - mock本地模拟数据
     */
    reqEnv: process.env.VUE_APP_RUN_ENV,
    // 是否强制使用reqEnv环境
    isUseReqEnv: true,
    // 是否开启桌面调试模式
    isDesk: false,
    // 端内页面路径
    openAppUrl: '',
    // 埋点的host
    buryingPointUrl: '',
    // 安卓下载引导页
    downloadGuid: ''
};

(function () {
    let env = process.env.NODE_ENV === 'production' ? 'pro' : 'dev'
    let source = {
        source_dev: {
            baseUrl: 'https://devapi.nfnews.com/',
            openAppUrl: 'https://devstatic.nfnews.com/apptpl/reporterWorksList/index.html',
            buryingPointUrl: 'https://devanalyticsapi.nfnews.com/analytics/sendRecord',
            downloadGuid: 'https://devstatic.nfnews.com/apptpl/downloadGuide/',
            shareNFNum: 'https://devstatic.nfnews.com/nfh/shareNFNum/index.html',
            privateLetterUrl: 'https://devmember.nfnews.com/'
        },
        source_test: {
            baseUrl: 'https://testapi.nfnews.com/',
            openAppUrl: 'https://teststatic.nfnews.com/apptpl/reporterWorksList/index.html',
            buryingPointUrl: 'https://testanalyticsapi.nfnews.com/analytics/sendRecord',
            downloadGuid: 'https://teststatic.nfnews.com/apptpl/downloadGuide/',
            shareNFNum: 'https://teststatic.nfnews.com/nfh/shareNFNum/index.html',
            privateLetterUrl: 'https://testmember.nfnews.com/'
        },
        source_pro: {
            baseUrl: 'https://api.nfapp.southcn.com/',
            openAppUrl: 'https://static.nfnews.com/apptpl/reporterWorksList/index.html',
            buryingPointUrl: 'https://analyticsapi.nfnews.com/analytics/sendRecord',
            downloadGuid: 'https://static.nfnews.com/apptpl/downloadGuide/',
            shareNFNum: 'https://static.nfnews.com/nfh/shareNFNum/index.html',
            privateLetterUrl: 'https://member.nfnews.com/'
        },
    }
    if (baseConfig.isUseReqEnv) {
        env = baseConfig.reqEnv
    }
    Object.assign(baseConfig, source[`source_${env}`])
})();

export default baseConfig